export type StatusSegment = 'open' | 'closed' | 'scheduled' | 'draft';

export const STATUS_SEGMENTS: {value: StatusSegment; label: string}[] = [
  {value: 'open', label: 'Open'},
  {value: 'closed', label: 'Closed'},
  {value: 'scheduled', label: 'Scheduled'},
  {value: 'draft', label: 'Draft'}
];

export const CREATE_ASSIGNMENT_PATH = '/assignment-builder/create-assignment';
